import { useNavigate } from "react-router-dom";
import useTranslator from "../../../hooks/useTranslator";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Modal,
  Row,
} from "react-bootstrap";
import { useContext, useEffect, useRef, useState } from "react";
import AuthContext from "../../../context/auth/AuthContext";
import constants from "../../../Utils/constants";
import { haveValue, skipMaccUser } from "../../../helper/common";
import TenantContext from "../../../context/tenant/TenantContext";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { toast } from "react-toastify";
import Loader from "../../../components/Spinner";
import DocCard from "../../../components/Tenant/DocCard";
import NewDocumentDiv from "../../../components/Tenant/NewDocumentDiv";
import moment from "moment";

const TenantProvideDocumentNew = () => {
  // const clave_docs = new Map();
  const { _t } = useTranslator();
  const claveDocDivRef = useRef(null);
  const queryParameters = new URLSearchParams(window.location.search);
  const modelType = queryParameters.get("type");
  const waitingId = queryParameters.get("waiting");
  const navigate = useNavigate();
  const authContext = useContext(AuthContext);
  const tenantContext = useContext(TenantContext);
  const {
    uploadFileData,
    fetchTenantDocs,
    updateTenant,
    initiateBankFlip,
    fetchWaitingData,
  } = tenantContext;
  const { user, loadUser } = authContext;
  const [tenantDocsData, setTenantDocsData] = useState([]);
  const [currentStep, setCurrentStep] = useState(() => {
    return skipMaccUser(user?.user_type) ? 1 : 0;
  });

  const [localLoading, setLocalLoading] = useState(false);
  const [doc_uploaded, set_doc_uploaded] = useState(false);
  const [otherDocsModel, setOtherDocsModel] = useState(false);
  const [tempUploadedFile, setTempUploadedFile] = useState(null);
  const [uploadFilePreview, setUploadFilePreview] = useState(null);
  const [uploadDocName, setUploadDocName] = useState({
    type: "",
    year: "",
    month: "",
  });

  const [docFound, setDocFound] = useState(new Map());
  const [otherDocs, setOtherDocs] = useState([]);
  const [manualDocName, setManualDocName] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    fetchFileData();
    if (haveValue(modelType) && modelType == "manual") {
      setCurrentStep(1);
    }
    if (haveValue(waitingId)) {
      setLocalLoading(true);
      set_doc_uploaded(true);
      const temp_interval = setInterval(() => {
        fetchWaitingData(waitingId)
          .then((res) => {
            if (res.status == constants.COMPLETED) {
              clearInterval(temp_interval);
              fetchFileData();
              setLocalLoading(false);
            }
          })
          .catch((err) => {
            setLocalLoading(false);
            clearInterval(temp_interval);
            console.log(err);
          });
      }, 1000);
    }
  }, []);

  useEffect(() => {
    if (haveValue(tenantDocsData) && tenantDocsData.length >= 1) {
      const temp_map = new Map();
      const type_map = new Map();
      const other_type = [];
      console.log(tenantDocsData, "IN USEEFFECT tenantDocsData");
      tenantDocsData.map((docs) => {
        if (docs?.from == "clave") {
          temp_map.set(docs?.type);
        }
        if (!type_map.has(docs?.type) && docs?.from != constants.others) {
          type_map.set(docs?.type, docs);
        }
        if (docs?.from == "others") {
          other_type.push(docs);
        }
      });
      setOtherDocs(other_type);
      setDocFound(type_map);
    }
  }, [tenantDocsData]);

  useEffect(() => {
    if (user) {
      let res = skipMaccUser(user?.user_type) ? true : false;
      if (res === true && currentStep === 0) {
        setCurrentStep(1);
      }
    }
  }, [user]);

  const navigateHome = () => {
    navigate("/tenant");
  };

  const fetchFileData = async () => {
    console.log("fetchFileData called");
    let userid = localStorage.getItem("saveduserid");
    const res = await fetchTenantDocs(userid);
    console.log(res.data.success_res.tenantDocs, "IN THIS FUNCTION");
    setTenantDocsData(res.data.success_res.tenantDocs);
  };

  const handleInitiateClave = async (e) => {
    let temp_clave_models = {
      AEAT_100_RENTA: false,
      AEAT_130_IRPF_DIRECTA: false,
      AEAT_303_IVA_AUTOLIQUIDACION: false,
      SEG_SOCIAL_VIDA_LABORAL: false,
      SEG_SOCIAL_CERT_INTEGRAL_PRESTACIONES: false,
      SEG_SOCIAL_BASE_COTIZACIONES: false,
    };

    if (user?.employment_status == constants.employed) {
      temp_clave_models = {
        ...temp_clave_models,
        SEG_SOCIAL_BASE_COTIZACIONES: true,
      };
    }
    if (
      user?.employment_status == constants.employed ||
      user?.employment_status == constants.unemployed
    ) {
      temp_clave_models = {
        ...temp_clave_models,
        SEG_SOCIAL_VIDA_LABORAL: true,
        AEAT_100_RENTA: true,
      };
    }
    if (user?.employment_status == constants.self_employed) {
      temp_clave_models = {
        ...temp_clave_models,
        SEG_SOCIAL_VIDA_LABORAL: true,
        AEAT_100_RENTA: true,
        AEAT_130_IRPF_DIRECTA: true,
      };
    }
    if (
      user?.employment_status == constants.self_employed &&
      user?.is_freelancer == true
    ) {
      temp_clave_models = {
        ...temp_clave_models,
        AEAT_303_IVA_AUTOLIQUIDACION: true,
      };
    }

    if (
      user?.employment_status == constants.retired ||
      user?.employment_status == constants.unemployed
    ) {
      temp_clave_models = {
        ...temp_clave_models,
        SEG_SOCIAL_CERT_INTEGRAL_PRESTACIONES: true,
      };
    }

    console.log(temp_clave_models, "check models here");

    initiateBankFlip(temp_clave_models)
      .then((res) => {
        window.location.replace(res.success_res.widgetLink);
        console.log(res, "BANK FLIP RESPONSE");
      })
      .catch((err) => {
        console.log(err);
        toast.error(_t("errorWhileInitiatingTheSignatureProcess"));
      });
    console.log("INITIATED CLAVE PIN");
  };

  const handleUploadFile = async (e) => {
    try {
      setLocalLoading(true);
      const val_type = e.target.dataset.val;
      const files = e.target.files;
      let file = files[0];
      const formData = new FormData();
      formData.append("tenantDocs", file);
      formData.append("fileType", val_type);
      console.log(file, val_type);
      await uploadFileData(formData);
      await fetchFileData();
      set_doc_uploaded(true);
      setLocalLoading(false);
    } catch (err) {
      setLocalLoading(false);
      console.log(err, "error inside handleUploadFile");
    }
  };

  const handleOtherUploadFile = async (e) => {
    try {
      setLocalLoading(true);
      const formData = new FormData();
      formData.append("tenantDocs", tempUploadedFile);
      formData.append(
        "fileType",
        uploadDocName.type === "other" ? manualDocName : uploadDocName.type
      );
      if (haveValue(uploadDocName.month)) {
        formData.append("month", uploadDocName.month);
      }
      if (haveValue(uploadDocName.year)) {
        formData.append("year", uploadDocName.year);
      }
      formData.append("fileFrom", constants.others);

      await uploadFileData(formData);
      await fetchFileData();
      set_doc_uploaded(true);
      setLocalLoading(false);
      handleCloseUploadModal();
    } catch (err) {
      setLocalLoading(false);
      console.log(err, "error inside handleOtherUploadFile");
    }
  };

  const handleChangeClavePinStatus = async (status) => {
    const sendData = {
      haveClavePin: status,
    };

    await updateTenant(sendData);
    await loadUser("tenant");
    claveDocDivRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  const handleTempUploadFile = async (e) => {
    console.log(e.target.files, "filedatahere", e.target.result);
    const files = e.target.files;
    let file = files[0];

    const url = URL.createObjectURL(file);
    setUploadFilePreview(url);
    setTempUploadedFile(file);
  };

  const handleCloseUploadModal = () => {
    setTempUploadedFile(null);
    setOtherDocsModel(false);
    setUploadFilePreview(null);
    setUploadDocName({ type: "", year: "", month: "" });
  };

  return (
    <>
      <div className="step-form-main-wrapper upload-new-flow spacing-setting-wrapper">
        <div className="d-flex step-absolute-header step-form-header ">
          <Container className="p-0 text-center back-btn">
            <div className="">
              <a href={undefined} onClick={navigateHome}>
                <img src="/images/back-btn-white.svg" alt="" />
                <span>{_t("goBackToHome")} </span>
              </a>
            </div>
          </Container>
          <h3 className="step-form-name mobile-model-heading">
            <img src="/images/document-home-icon.svg" alt="" />
            <span>{_t("provideDocuments")}</span>
          </h3>
          <div className="">
            {doc_uploaded && (
              <button
                className="rounded-check summaryinfobar btn btngreen done-btn"
                id="viewDocumentBtn"
                onClick={navigateHome}
              >
                {_t("done")} <img src="/images/Tick.svg" alt="" />
              </button>
            )}
          </div>
        </div>
        <>
          {/* <div className="container"> */}
          <div className="row">
            <div className="col-12">
              <div className=" text-center provide-doc-info">
                <p className="warning-text">
                  {" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="24"
                    viewBox="0 0 25 24"
                    fill="none"
                  >
                    <path
                      d="M11.3 6H13.7V8.4H11.3V6ZM11.3 10.8H13.7V18H11.3V10.8ZM12.5 0C5.876 0 0.5 5.376 0.5 12C0.5 18.624 5.876 24 12.5 24C19.124 24 24.5 18.624 24.5 12C24.5 5.376 19.124 0 12.5 0ZM12.5 21.6C7.208 21.6 2.9 17.292 2.9 12C2.9 6.708 7.208 2.4 12.5 2.4C17.792 2.4 22.1 6.708 22.1 12C22.1 17.292 17.792 21.6 12.5 21.6Z"
                      fill="#EF7833"
                    />
                  </svg>{" "}
                  <span>
                    {_t(
                      "documentListShownBelowDependsUponEmploymentStatusSelected"
                    )}{" "}
                    <strong>
                      {user?.employment_status == "self_employed"
                        ? user?.is_freelancer
                          ? _t("freelancer")
                          : _t("selfEmployed")
                        : _t(user?.employment_status)}
                    </strong>
                  </span>
                  <a
                    href={undefined}
                    onClick={(e) => navigate("/edit-profile/tenant#employment")}
                    className="btn btndarkgreen edit-status"
                  >
                    {_t("editStatus")}
                  </a>
                </p>
              </div>
            </div>
            <div className="col-12 grid-wrapper">
              {(user?.employment_status == constants.employed ||
                user?.employment_status == constants.self_employed ||
                user?.employment_status == constants.unemployed ||
                user?.employment_status == constants.retired) && (
                // <div className="col-3ddd">
                <div
                  className={`calvepin-option-div tenant-left-box 
                ${
                  // haveValue(user?.haveClavePin) &&
                  // !user?.haveClavePin &&
                  // "tenant-light-box"
                  ""
                }
                 `}
                >
                  {/* for light color= tenant-light-box */}
                  <div className="tennat-left-box-top">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <img src="/images/clavePinLightGreen.svg" alt="" />
                      <ul className="infodorpdown summarydropdum">
                        <li>
                          <button className="iconinfo">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              className=""
                            >
                              <path
                                d="M10.8 6H13.2V8.4H10.8V6ZM10.8 10.8H13.2V18H10.8V10.8ZM12 0C5.376 0 0 5.376 0 12C0 18.624 5.376 24 12 24C18.624 24 24 18.624 24 12C24 5.376 18.624 0 12 0ZM12 21.6C6.708 21.6 2.4 17.292 2.4 12C2.4 6.708 6.708 2.4 12 2.4C17.292 2.4 21.6 6.708 21.6 12C21.6 17.292 17.292 21.6 12 21.6Z"
                                fill="white"
                              />
                            </svg>
                          </button>{" "}
                        </li>
                        <ul className="tooltip">
                          <span>{_t("whatDoINeedToConnectWithClavePin")}</span>
                          <ul>
                            <li>{_t("dniNumberAndvalidityDate")}</li>
                            <li>
                              {_t(
                                "telephoneAssociatedWithClavePinToReceiveAccessCodesViaSms"
                              )}
                            </li>
                          </ul>
                        </ul>
                      </ul>
                    </div>
                    <h4 className="sidebar-inner-heading">
                      {_t("getFromClavePin")}
                    </h4>
                    <p>
                      {_t(
                        "provideYourDocumentsToSkorViaClavePinWithEaseAndEfficiency"
                      )}
                    </p>
                    <h5 className="document-heading">{_t("certificates")}</h5>
                    <ul className="list-style-disc">
                      {user?.employment_status == constants.employed && (
                        <li>
                          <p>{_t("deductionCertificate")}</p>
                        </li>
                      )}
                      {(user?.employment_status == constants.employed ||
                        user?.employment_status == constants.self_employed ||
                        user?.employment_status == constants.unemployed) && (
                        <>
                          <li>
                            <p>{_t("workingLifeCertificate")}</p>
                          </li>
                          <li>
                            <p>{_t("lastAnnualTaxReportModel100")}</p>
                          </li>
                        </>
                      )}

                      {user?.employment_status == constants.self_employed && (
                        <li>
                          <p>{_t("lastFractionatedTaxReportModel130")}</p>
                        </li>
                      )}
                      {user?.employment_status == constants.self_employed &&
                        user?.is_freelancer == true && (
                          <li>
                            <p>{_t("lastQuarterlyVATTaxForm303")}</p>
                          </li>
                        )}
                      {(user?.employment_status == constants.retired ||
                        user?.employment_status == constants.unemployed) && (
                        <li>
                          <p>{_t("comprehensiveCertificateOfBenefits")}</p>
                        </li>
                      )}
                    </ul>
                  </div>
                  <div className="tenant-left-box-bottom">
                    {/* {haveValue(user?.haveClavePin) && !user?.haveClavePin ? (
                    <button
                      className="btn btngreen light-box-btn btndarkgreen"
                      onClick={(e) => handleChangeClavePinStatus(true)}
                    >
                      {_t("enableClavePin")}{" "}
                      <img
                        src="/images/lightGreenRightArrow.svg"
                        alt=""
                        className="mb-0"
                      />
                    </button>
                  ) : (
                    <>
                      <button
                        className="btn btngreen"
                        onClick={handleInitiateClave}
                      >
                        {_t("getFromClavePin")}{" "}
                        <img
                          src="/images/rightArrow.svg"
                          alt=""
                          className="mb-0"
                        />
                      </button>
                      <a
                        href={undefined}
                        onClick={(e) => handleChangeClavePinStatus(false)}
                        className="white-text underline tennat-eft-content-btn"
                      >
                        {_t("dontHaveClavePin")}
                      </a>
                    </>
                  )} */}
                    <button
                      className="btn btngreen"
                      onClick={handleInitiateClave}
                    >
                      {_t("getFromClavePin")}{" "}
                      <img
                        src="/images/rightArrow.svg"
                        alt=""
                        className="mb-0"
                      />
                    </button>
                    {haveValue(user?.haveClavePin) && !user?.haveClavePin ? (
                      ""
                    ) : (
                      <a
                        href={undefined}
                        onClick={(e) => handleChangeClavePinStatus(false)}
                        className="white-text underline tennat-eft-content-btn"
                      >
                        {_t("dontHaveClavePin")}
                      </a>
                    )}
                  </div>
                </div>
                // </div>
              )}
              {/* <div className="col-md-9ddd tenant-right-box"> */}

              <div className="">
                <div className=" d-flex add-more-doc-card flex-column justify-content-center text-center align-items-center">
                  <p className="more-doc-label">
                    {_t("wantToAddMoreDocuments")}
                  </p>
                  <button
                    className="btn btngreen edit-status"
                    onClick={(e) => setOtherDocsModel(true)}
                  >
                    {_t("addNow")}
                  </button>
                </div>
              </div>
              {localLoading ? (
                <Loader waiting_text={_t("uploadingDocs")} />
              ) : (
                // <div className="row">
                <>
                  {user?.employment_status == constants.student && (
                    <>
                      {docFound.has(constants.university_acceptance_letter) ? (
                        <DocCard
                          file_data={docFound.get(
                            constants.university_acceptance_letter
                          )}
                          doc_type={constants.university_acceptance_letter}
                          handleUploadFile={handleUploadFile}
                        />
                      ) : (
                        <NewDocumentDiv
                          dataVal={constants.university_acceptance_letter}
                          handleUploadFile={handleUploadFile}
                          title={_t("universityAcceptanceLetter")}
                        />
                      )}

                      {docFound.has(constants.ie_student) ? (
                        <DocCard
                          file_data={docFound.get(constants.ie_student)}
                          doc_type={constants.ie_student}
                          handleUploadFile={handleUploadFile}
                        />
                      ) : (
                        <NewDocumentDiv
                          dataVal={constants.ie_student}
                          title={_t("studentRegistrationContract")}
                          handleUploadFile={handleUploadFile}
                        />
                      )}
                    </>
                  )}

                  {user?.employment_status == constants.employed && (
                    <>
                      {docFound.has(constants.firstMonthPayslip) ? (
                        <DocCard
                          file_data={docFound.get(constants.firstMonthPayslip)}
                          handleUploadFile={handleUploadFile}
                          doc_type={constants.firstMonthPayslip}
                        />
                      ) : (
                        <NewDocumentDiv
                          dataVal={constants.firstMonthPayslip}
                          title={_t("firstMonthPayslip")}
                          handleUploadFile={handleUploadFile}
                        />
                      )}
                      {docFound.has(constants.secondMonthPayslip) ? (
                        <DocCard
                          file_data={docFound.get(constants.secondMonthPayslip)}
                          handleUploadFile={handleUploadFile}
                          doc_type={constants.secondMonthPayslip}
                        />
                      ) : (
                        <NewDocumentDiv
                          dataVal={constants.secondMonthPayslip}
                          title={_t("secondMonthPayslip")}
                          handleUploadFile={handleUploadFile}
                        />
                      )}
                      {docFound.has(constants.thirdMonthPayslip) ? (
                        <DocCard
                          file_data={docFound.get(constants.thirdMonthPayslip)}
                          handleUploadFile={handleUploadFile}
                          doc_type={constants.thirdMonthPayslip}
                        />
                      ) : (
                        <NewDocumentDiv
                          dataVal={constants.thirdMonthPayslip}
                          title={_t("thirdMonthPayslip")}
                          handleUploadFile={handleUploadFile}
                        />
                      )}
                      {docFound.has(constants.employment_contract) ? (
                        <DocCard
                          file_data={docFound.get(
                            constants.employment_contract
                          )}
                          handleUploadFile={handleUploadFile}
                          doc_type={constants.employment_contract}
                        />
                      ) : (
                        <NewDocumentDiv
                          dataVal={constants.employment_contract}
                          title={_t("employmentContract")}
                          handleUploadFile={handleUploadFile}
                        />
                      )}
                      {docFound.has(
                        constants.public_appointment_certificate
                      ) ? (
                        <DocCard
                          file_data={docFound.get(
                            constants.public_appointment_certificate
                          )}
                          handleUploadFile={handleUploadFile}
                          doc_type={constants.public_appointment_certificate}
                        />
                      ) : (
                        <NewDocumentDiv
                          dataVal={constants.public_appointment_certificate}
                          title={_t(
                            "publicAppointmentCertificateOnlyIfPublicEmployee"
                          )}
                          handleUploadFile={handleUploadFile}
                        />
                      )}
                    </>
                  )}
                  {user?.employment_status == constants.self_employed &&
                    user?.is_freelancer != true && (
                      <>
                        {docFound.has(constants.corporate_tax_return) ? (
                          <DocCard
                            file_data={docFound.get(
                              constants.corporate_tax_return
                            )}
                            handleUploadFile={handleUploadFile}
                            doc_type={constants.corporate_tax_return}
                          />
                        ) : (
                          <NewDocumentDiv
                            dataVal={constants.corporate_tax_return}
                            title={_t("lastYearsCorporateTaxReturn")}
                            handleUploadFile={handleUploadFile}
                          />
                        )}
                        {docFound.has(constants.corporate_balance_sheet) ? (
                          <DocCard
                            file_data={docFound.get(
                              constants.corporate_balance_sheet
                            )}
                            handleUploadFile={handleUploadFile}
                            doc_type={constants.corporate_balance_sheet}
                          />
                        ) : (
                          <NewDocumentDiv
                            dataVal={constants.corporate_balance_sheet}
                            title={_t("lastYearsCorporateBalanceSheet")}
                            handleUploadFile={handleUploadFile}
                          />
                        )}
                        {docFound.has(constants.corporate_PL) ? (
                          <DocCard
                            file_data={docFound.get(constants.corporate_PL)}
                            handleUploadFile={handleUploadFile}
                            doc_type={constants.corporate_PL}
                          />
                        ) : (
                          <NewDocumentDiv
                            dataVal={constants.corporate_PL}
                            title={_t("lastYearsCorporatePAndL")}
                            handleUploadFile={handleUploadFile}
                          />
                        )}
                      </>
                    )}
                  {user?.employment_status == constants.self_employed &&
                    user?.is_freelancer == true && (
                      <>
                        {/* {docFound.has(constants.firstMonthPayslip) ? (
                          <DocCard
                            file_data={docFound.get(
                              constants.firstMonthPayslip
                            )}
                            handleUploadFile={handleUploadFile}
                            doc_type={constants.firstMonthPayslip}
                          />
                        ) : (
                          <NewDocumentDiv
                            dataVal={constants.firstMonthPayslip}
                            title={_t("firstMonthPayslip")}
                            handleUploadFile={handleUploadFile}
                          />
                        )}
                        {docFound.has(constants.secondMonthPayslip) ? (
                          <DocCard
                            file_data={docFound.get(
                              constants.secondMonthPayslip
                            )}
                            handleUploadFile={handleUploadFile}
                            doc_type={constants.secondMonthPayslip}
                          />
                        ) : (
                          <NewDocumentDiv
                            dataVal={constants.secondMonthPayslip}
                            title={_t("secondMonthPayslip")}
                            handleUploadFile={handleUploadFile}
                          />
                        )}
                        {docFound.has(constants.thirdMonthPayslip) ? (
                          <DocCard
                            file_data={docFound.get(
                              constants.thirdMonthPayslip
                            )}
                            handleUploadFile={handleUploadFile}
                            doc_type={constants.thirdMonthPayslip}
                          />
                        ) : (
                          <NewDocumentDiv
                            dataVal={constants.thirdMonthPayslip}
                            title={_t("thirdMonthPayslip")}
                            handleUploadFile={handleUploadFile}
                          />
                        )} */}
                        {docFound.has(constants.employment_contract) ? (
                          <DocCard
                            file_data={docFound.get(
                              constants.employment_contract
                            )}
                            handleUploadFile={handleUploadFile}
                            doc_type={constants.employment_contract}
                          />
                        ) : (
                          <NewDocumentDiv
                            dataVal={constants.employment_contract}
                            title={_t("employmentContract")}
                            handleUploadFile={handleUploadFile}
                          />
                        )}
                        {/* {docFound.has(constants.corporate_tax_return) ? (
                          <DocCard
                            file_data={docFound.get(
                              constants.corporate_tax_return
                            )}
                            handleUploadFile={handleUploadFile}
                            doc_type={constants.corporate_tax_return}
                          />
                        ) : (
                          <NewDocumentDiv
                            dataVal={constants.corporate_tax_return}
                            title={_t("lastYearsCorporateTaxReturn")}
                            handleUploadFile={handleUploadFile}
                          />
                        )}
                        {docFound.has(constants.corporate_balance_sheet) ? (
                          <DocCard
                            file_data={docFound.get(
                              constants.corporate_balance_sheet
                            )}
                            handleUploadFile={handleUploadFile}
                            doc_type={constants.corporate_balance_sheet}
                          />
                        ) : (
                          <NewDocumentDiv
                            dataVal={constants.corporate_balance_sheet}
                            title={_t("lastYearsCorporateBalanceSheet")}
                            handleUploadFile={handleUploadFile}
                          />
                        )}
                        {docFound.has(constants.corporate_PL) ? (
                          <DocCard
                            file_data={docFound.get(constants.corporate_PL)}
                            handleUploadFile={handleUploadFile}
                            doc_type={constants.corporate_PL}
                          />
                        ) : (
                          <NewDocumentDiv
                            dataVal={constants.corporate_PL}
                            title={_t("lastYearsCorporatePAndL")}
                            handleUploadFile={handleUploadFile}
                          />
                        )} */}
                      </>
                    )}
                  {user?.employment_status == constants.retired && (
                    <>
                      {/* {docFound.has(constants.pension_certificate) ? (
                        <DocCard
                          file_data={docFound.get(
                            constants.pension_certificate
                          )}
                          handleUploadFile={handleUploadFile}
                          doc_type={constants.pension_certificate}
                        />
                      ) : (
                        <NewDocumentDiv
                          dataVal={constants.pension_certificate}
                          title={_t("pensionCertificate")}
                          handleUploadFile={handleUploadFile}
                        />
                      )} */}
                      {docFound.has(constants.last_revalorization_letter) ? (
                        <DocCard
                          file_data={docFound.get(
                            constants.last_revalorization_letter
                          )}
                          handleUploadFile={handleUploadFile}
                          doc_type={constants.last_revalorization_letter}
                        />
                      ) : (
                        <NewDocumentDiv
                          dataVal={constants.last_revalorization_letter}
                          title={_t("lastRevalorizationLetter")}
                          handleUploadFile={handleUploadFile}
                        />
                      )}
                    </>
                  )}
                  {/* </div> */}
                </>
              )}
              {/* </div> */}
              {/* <div className="row other_docs_div"> */}

              {Array.isArray(otherDocs) &&
                otherDocs?.length > 0 &&
                otherDocs.map((doc) => (
                  <DocCard
                    column_width={4}
                    file_data={doc}
                    doc_type={constants.others}
                    handleUploadFile={handleUploadFile}
                    allowReUpload={false}
                  />
                ))}

              {/* </div> */}
            </div>
          </div>
          {/* </div> */}

          <div
            className="row clave-box-bottom clave-box-setting"
            ref={claveDocDivRef}
          >
            {(!haveValue(user?.haveClavePin) &&
              user?.employment_status != constants.student) ||
              (user?.haveClavePin && <h3>{_t("fromClavePin")}</h3>)}
            {(user?.employment_status == constants.employed ||
              user?.employment_status == constants.self_employed ||
              user?.employment_status == constants.unemployed) && (
              <>
                {docFound.has(constants.previous_working_life_certificate) ? (
                  <DocCard
                    column_width={3}
                    file_data={docFound.get(
                      constants.previous_working_life_certificate
                    )}
                    doc_type={constants.previous_working_life_certificate}
                    handleUploadFile={handleUploadFile}
                    allowReUpload={
                      !(!haveValue(user?.haveClavePin) || user?.haveClavePin)
                    }
                  />
                ) : (
                  <NewDocumentDiv
                    column_width={3}
                    dataVal={constants.previous_working_life_certificate}
                    handleUploadFile={handleUploadFile}
                    title={_t("workingLifeCertificate")}
                    hideUpload={
                      !haveValue(user?.haveClavePin) || user?.haveClavePin
                    }
                  />
                )}
                {console.log(
                  docFound.has(constants.income_tax_return),
                  docFound,
                  "DOCUMENTS LIST IS HERE"
                )}
                {docFound.has(constants.income_tax_return) ? (
                  <DocCard
                    column_width={3}
                    file_data={docFound.get(constants.income_tax_return)}
                    doc_type={constants.income_tax_return}
                    handleUploadFile={handleUploadFile}
                    allowReUpload={
                      !(!haveValue(user?.haveClavePin) || user?.haveClavePin)
                    }
                  />
                ) : (
                  <NewDocumentDiv
                    column_width={3}
                    dataVal={constants.income_tax_return}
                    handleUploadFile={handleUploadFile}
                    title={_t("lastAnnualTaxReportModel100")}
                    hideUpload={
                      !haveValue(user?.haveClavePin) || user?.haveClavePin
                    }
                  />
                )}
              </>
            )}
            {user?.employment_status == constants.employed &&
              (docFound.has(constants.deduction_certificate) ? (
                <DocCard
                  column_width={3}
                  file_data={docFound.get(constants.deduction_certificate)}
                  handleUploadFile={handleUploadFile}
                  doc_type={constants.deduction_certificate}
                  allowReUpload={
                    !(!haveValue(user?.haveClavePin) || user?.haveClavePin)
                  }
                />
              ) : (
                <NewDocumentDiv
                  column_width={3}
                  dataVal={constants.deduction_certificate}
                  title={_t("deductionCertificate")}
                  handleUploadFile={handleUploadFile}
                  hideUpload={
                    !haveValue(user?.haveClavePin) || user?.haveClavePin
                  }
                />
              ))}

            {(user?.employment_status == constants.unemployed ||
              user?.employment_status == constants.retired) &&
              (docFound.has(constants.comprehensive_certificate_of_benefits) ? (
                <DocCard
                  column_width={3}
                  file_data={docFound.get(
                    constants.comprehensive_certificate_of_benefits
                  )}
                  doc_type={constants.comprehensive_certificate_of_benefits}
                  handleUploadFile={handleUploadFile}
                  allowReUpload={
                    !(!haveValue(user?.haveClavePin) || user?.haveClavePin)
                  }
                />
              ) : (
                <NewDocumentDiv
                  column_width={3}
                  dataVal={constants.comprehensive_certificate_of_benefits}
                  handleUploadFile={handleUploadFile}
                  title={_t("comprehensiveCertificateOfBenefits")}
                  hideUpload={
                    !haveValue(user?.haveClavePin) || user?.haveClavePin
                  }
                />
              ))}

            {user?.employment_status == constants.self_employed && (
              <>
                {docFound.has(constants.fractioned_tax_return) ? (
                  <DocCard
                    column_width={3}
                    file_data={docFound.get(constants.fractioned_tax_return)}
                    doc_type={constants.fractioned_tax_return}
                    handleUploadFile={handleUploadFile}
                    allowReUpload={
                      !(!haveValue(user?.haveClavePin) || user?.haveClavePin)
                    }
                  />
                ) : (
                  <NewDocumentDiv
                    column_width={3}
                    dataVal={constants.fractioned_tax_return}
                    handleUploadFile={handleUploadFile}
                    title={_t("lastFractionatedTaxReportModel130")}
                    hideUpload={
                      !haveValue(user?.haveClavePin) || user?.haveClavePin
                    }
                  />
                )}
              </>
            )}

            {user?.employment_status == constants.self_employed &&
              user?.is_freelancer == true && (
                <>
                  {docFound.has(constants.quarterly_vat) ? (
                    <DocCard
                      column_width={3}
                      file_data={docFound.get(constants.quarterly_vat)}
                      doc_type={constants.quarterly_vat}
                      handleUploadFile={handleUploadFile}
                      allowReUpload={
                        !(!haveValue(user?.haveClavePin) || user?.haveClavePin)
                      }
                    />
                  ) : (
                    <NewDocumentDiv
                      column_width={3}
                      dataVal={constants.quarterly_vat}
                      handleUploadFile={handleUploadFile}
                      title={_t("lastQuarterlyVATTaxForm303")}
                      hideUpload={
                        !haveValue(user?.haveClavePin) || user?.haveClavePin
                      }
                    />
                  )}
                </>
              )}
          </div>
        </>
      </div>
      <Modal
        show={otherDocsModel}
        onHide={handleCloseUploadModal}
        centered
        className="newmodalui asguarantor"
      >
        <Modal.Header closeButton>
          <Modal.Title>{_t("addMoreDocuments")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="info-wapper col-12">
              <label htmlFor="">{_t("documentType")}</label>
              {/* <input
              type="text"
              className="form-control"
              value={uploadDocName}
              onChange={(e) => setUploadDocName(e.target.value)}
            /> */}
              <select
                className="custom-input"
                name="otherDocName"
                id="otherDocName"
                value={uploadDocName.type}
                onChange={(e) =>
                  setUploadDocName({
                    type: e.target.value,
                    year: "",
                    month: "",
                  })
                }
              >
                <option value="">{_t("select")}</option>
                <option value={constants.fractioned_tax_return}>
                  {_t("lastFractionatedTaxReportModel130")}
                </option>
                <option value={constants.payslip}>{_t("payslip")}</option>
                <option value={constants.income_tax_return}>
                  {_t("lastAnnualTaxReportModel100")}
                </option>
                <option
                  value={constants.certificate_of_social_security_compliance}
                >
                  {_t(
                    "certificateOfSocialSecurityCompliance",
                    "Other Document Type"
                  )}
                </option>
                <option value={constants.certificate_of_tax_compliance}>
                  {_t("certificateOfTaxCompliance", "Other Document Type")}
                </option>
                <option value={constants.annual_corporate_tax}>
                  {_t("annualCorporateTax", "Other Document Type")}
                </option>
                <option value={constants.certificate_of_account_ownership}>
                  {_t("certificateOfAccountOwnership", "Other Document Type")}
                </option>
                <option value={constants.certificate_of_account_balance}>
                  {_t("certificateOfAccountBalance", "Other Document Type")}
                </option>
                <option value={constants.alternative_income_sources}>
                  {_t("alternativeIncomeSources", "Other Document Type")}
                </option>
                <option value={constants.recent_utility_bill}>
                  {_t(
                    "recentUtilityBillPhoneElectricityWaterOrInternet",
                    "Other Document Type"
                  )}
                </option>
                <option value={constants.OTHER}>{_t("other")}</option>
              </select>
            </div>
            <div className=" info-wapper w-100">
              {(uploadDocName.type == constants.fractioned_tax_return ||
                uploadDocName.type == constants.payslip ||
                uploadDocName.type == constants.income_tax_return ||
                uploadDocName.type == constants.annual_corporate_tax) && (
                <>
                  <div className="info-wapper flex-1 w-100">
                    <label htmlFor="">{_t("documentName")}</label>
                    <select
                      className="custom-input"
                      name="yearSelection"
                      id="yearSelection"
                      value={uploadDocName.year}
                      onChange={(e) =>
                        setUploadDocName((prev) => ({
                          ...prev,
                          year: e.target.value,
                        }))
                      }
                    >
                      <option value="">{_t("select")}</option>
                      <option value={moment().year()}>
                        {_t("currentYear", "While uploading other docs.")}
                      </option>
                      <option value={moment().subtract(1, "year").year()}>
                        {_t("previousYear", "While uploading other docs.")}
                      </option>
                    </select>
                  </div>
                </>
              )}

              {(uploadDocName.type == constants.fractioned_tax_return ||
                uploadDocName.type == constants.payslip) && (
                <div className="info-wapper flex-1 w-100">
                  <label htmlFor="">{_t("documentName")}</label>
                  <select
                    className="custom-input"
                    name="monthSelection"
                    id="monthSelection"
                    value={uploadDocName.month}
                    onChange={(e) =>
                      setUploadDocName((prev) => ({
                        ...prev,
                        month: e.target.value,
                      }))
                    }
                  >
                    {uploadDocName.type == constants.fractioned_tax_return && (
                      <>
                        <option value="">{_t("select")}</option>
                        <option value={_t("firstQuater")}>
                          {_t(
                            "firstQuater",
                            "while selecting quater when uploading other docs"
                          )}
                        </option>
                        <option value={_t("secondQuater")}>
                          {_t(
                            "secondQuater",
                            "while selecting quater when uploading other docs"
                          )}
                        </option>
                        <option value={_t("thirdQuater")}>
                          {_t(
                            "thirdQuater",
                            "while selecting quater when uploading other docs"
                          )}
                        </option>
                        <option value={_t("fourthQuater")}>
                          {_t(
                            "fourthQuater",
                            "while selecting quater when uploading other docs"
                          )}
                        </option>
                      </>
                    )}
                    {uploadDocName.type === constants.payslip && (
                      <>
                        <option value="">{_t("select")}</option>
                        {[...Array(12)].map((_, i) => (
                          <option key={i} value={i}>
                            {i + 1}
                          </option>
                        ))}
                      </>
                    )}
                  </select>
                </div>
              )}

              {uploadDocName.type == constants.OTHER && (
                <div>
                  <div className="info-wappercol-lg-12">
                    <label htmlFor="docName">{_t("documentName")}</label>
                    <input
                      type="text"
                      className="documenttype-div"
                      placeholder={_t("enterDocumentName")}
                      name="docName"
                      value={manualDocName}
                      onChange={(e) => setManualDocName(e.target.value)}
                    />
                  </div>
                </div>
              )}
            </div>
            {/* status */}
            <div className="info-wapper flex-1 mt-3 w-100">
              <label htmlFor="" className="">
                {_t("uploadDocument")}
              </label>
            </div>
            {haveValue(uploadFilePreview) ? (
              <div className="d-flex justify-content-center">
                <DocCard
                  column_width={6}
                  file_data={uploadFilePreview}
                  doc_type={constants.others}
                  handleUploadFile={handleTempUploadFile}
                  temp_file={true}
                />
              </div>
            ) : (
              <div>
                <div className="doc_upload_div_frame tenant-revisit-pdf-box">
                  <img
                    className="uploadDocPlaceholder"
                    src="/images/uploadDocPlaceholder.svg"
                    alt=""
                  />
                  <h4>{_t("otherDocument")}</h4>
                  <p className="info-text-p">{_t("uploadPdfPngJpgOrJpeg")}</p>

                  <label>
                    <input
                      accept="application/pdf, image/jpeg, image/png, image/jpg"
                      multiple={false}
                      type="file"
                      onChange={handleTempUploadFile}
                      className="d-none"
                    />
                    <span className="btn btngreen">
                      {_t("upload")} <img src="/images/uploadIcon.svg" alt="" />
                    </span>
                  </label>
                </div>
              </div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btngreen w-100"
            disabled={!haveValue(uploadDocName) || !haveValue(tempUploadedFile)}
            onClick={handleOtherUploadFile}
          >
            {" "}
            {_t("submit")}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default TenantProvideDocumentNew;
